module.exports = __webpack_public_path__ + "static/media/img183.bcbcd236.jpg";